(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-title"]) return;
  try {
    
  if (!customElements.get('collection-description')) {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.collection-description__content');
        this.button = this.querySelector('.collection-description__toggle');
        this.label = this.button?.querySelector('span');

        if (!this.content || !this.button || !this.label) return;

        this.handleClick = this.handleClick.bind(this);
        this.updateMeasurements = this.updateMeasurements.bind(this);
        this.button.addEventListener('click', this.handleClick);
        this.setAttribute('data-ready', '');
        this.resizeObserver = new ResizeObserver(this.updateMeasurements);
        this.resizeObserver.observe(this.content);
        this.updateMeasurements();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.resizeObserver?.disconnect();
      }

      handleClick() {
        const expanded = this.button.getAttribute('aria-expanded') !== 'true';
        this.content.toggleAttribute('data-expanded', expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.label.textContent = expanded
          ? this.button.dataset.expandedLabel
          : this.button.dataset.collapsedLabel;
      }

      updateMeasurements() {
        const styles = getComputedStyle(this.content);
        const fontSize = Number.parseFloat(styles.fontSize);
        const lineHeight = Number.parseFloat(styles.lineHeight) || fontSize * 1.5;
        const collapsedHeight = lineHeight * 3;
        const expandedHeight = this.content.scrollHeight;

        this.style.setProperty('--collection-description-collapsed-height', `${collapsedHeight}px`);
        this.style.setProperty('--collection-description-expanded-height', `${expandedHeight}px`);
        this.toggleAttribute('data-overflow', expandedHeight > collapsedHeight + 1);
      }
    }

    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();
})();
